/* Free shipping progress bar by US state — Papa Did It
 * Loaded by sections/free-shipping-state.liquid (footer group).
 * Thresholds come from window.pdiShipState (editable in the theme editor).
 * State lists below must match Settings → Shipping and delivery zones.
 */
(function () {
  if (window.__pdiFsbLoaded) return;
  window.__pdiFsbLoaded = true;

  var CFG = window.pdiShipState || {};
  var GOALS = {
    near: (parseFloat(CFG.near) || 80) * 100,
    mid: (parseFloat(CFG.mid) || 120) * 100,
    far: (parseFloat(CFG.far) || 150) * 100
  };

  var NEAR = ['NY', 'NJ', 'PA'];
  var WEST = ['AZ', 'CA', 'NV', 'OR', 'UT', 'WA', 'TX', 'ID', 'CO', 'MT', 'WY', 'NM'];

  var STATES = {
    AL: 'Alabama', AK: 'Alaska', AZ: 'Arizona', AR: 'Arkansas', CA: 'California',
    CO: 'Colorado', CT: 'Connecticut', DE: 'Delaware', DC: 'District of Columbia',
    FL: 'Florida', GA: 'Georgia', ID: 'Idaho', IL: 'Illinois', IN: 'Indiana',
    IA: 'Iowa', KS: 'Kansas', KY: 'Kentucky', LA: 'Louisiana', ME: 'Maine',
    MD: 'Maryland', MA: 'Massachusetts', MI: 'Michigan', MN: 'Minnesota',
    MS: 'Mississippi', MO: 'Missouri', MT: 'Montana', NE: 'Nebraska', NV: 'Nevada',
    NH: 'New Hampshire', NJ: 'New Jersey', NM: 'New Mexico', NY: 'New York',
    NC: 'North Carolina', ND: 'North Dakota', OH: 'Ohio', OK: 'Oklahoma',
    OR: 'Oregon', PA: 'Pennsylvania', RI: 'Rhode Island', SC: 'South Carolina',
    SD: 'South Dakota', TN: 'Tennessee', TX: 'Texas', UT: 'Utah', VT: 'Vermont',
    VA: 'Virginia', WA: 'Washington', WV: 'West Virginia', WI: 'Wisconsin',
    WY: 'Wyoming'
  };

  // Where the bar goes: cart drawer footer and cart page footer.
  var TARGETS = ['#CartDrawer .cart-drawer__footer', '#main-cart-footer .js-contents'];

  var KEY = 'pdi_ship_state';
  var state = null;
  var cart = { total: 0, count: 0 };
  var geoAsked = false;

  function saved() {
    try { return window.localStorage.getItem(KEY); } catch (e) { return null; }
  }
  function save(code) {
    try { window.localStorage.setItem(KEY, code); } catch (e) {}
  }

  function codeFromName(name) {
    if (!name) return null;
    var n = String(name).toLowerCase();
    for (var code in STATES) if (STATES[code].toLowerCase() === n) return code;
    return null;
  }

  function detectByIp() {
    if (geoAsked) return;
    geoAsked = true;
    var cached = null;
    try { cached = window.sessionStorage.getItem(KEY + '_ip'); } catch (e) {}
    var p = cached !== null
      ? Promise.resolve(cached || null)
      : fetch('https://get.geojs.io/v1/ip/geo.json')
          .then(function (r) { return r.json(); })
          .then(function (d) { return d && d.country_code === 'US' ? codeFromName(d.region) : null; })
          .catch(function () { return null; })
          .then(function (code) {
            try { window.sessionStorage.setItem(KEY + '_ip', code || ''); } catch (e) {}
            return code;
          });
    p.then(function (code) {
      if (code && STATES[code] && !state) { state = code; renderAll(); }
    });
  }

  function money(cents) {
    var v = cents / 100;
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }

  function goalFor(code) {
    if (NEAR.indexOf(code) > -1) return GOALS.near;
    if (WEST.indexOf(code) > -1) return GOALS.far;
    return GOALS.mid;
  }

  function build() {
    var el = document.createElement('div');
    el.className = 'fsb';
    var opts = '<option value="">Select state</option>';
    for (var code in STATES) opts += '<option value="' + code + '">' + STATES[code] + '</option>';
    el.innerHTML =
      '<label class="fsb__row"><span class="fsb__label">Shipping to</span>' +
      '<select class="fsb__select" aria-label="Shipping state">' + opts + '</select></label>' +
      '<p class="fsb__msg" aria-live="polite"></p>' +
      '<div class="fsb__track" hidden><div class="fsb__fill"></div></div>';
    el.querySelector('.fsb__select').addEventListener('change', function (e) {
      state = e.target.value || null;
      if (state) save(state);
      renderAll();
    });
    return el;
  }

  function render(el) {
    var select = el.querySelector('.fsb__select');
    var msg = el.querySelector('.fsb__msg');
    var track = el.querySelector('.fsb__track');
    var fill = el.querySelector('.fsb__fill');
    el.hidden = cart.count === 0;
    select.value = state || '';
    if (!state) {
      msg.textContent = 'Choose your state to see your free shipping threshold.';
      track.hidden = true;
      el.classList.remove('fsb--done');
      return;
    }
    var goal = goalFor(state);
    var left = goal - cart.total;
    track.hidden = false;
    fill.style.width = Math.min(100, (cart.total / goal) * 100) + '%';
    if (left <= 0) {
      msg.textContent = "You've got free shipping to " + STATES[state] + '!';
      el.classList.add('fsb--done');
    } else {
      msg.innerHTML = 'Only <strong>' + money(left) + '</strong> away from free shipping to ' + STATES[state];
      el.classList.remove('fsb--done');
    }
  }

  function renderAll() {
    document.querySelectorAll('.fsb').forEach(render);
  }

  function ensureBars() {
    TARGETS.forEach(function (sel) {
      var host = document.querySelector(sel);
      if (!host || host.querySelector('.fsb')) return;
      var bar = build();
      var totals = host.querySelector('.totals');
      if (totals) host.insertBefore(bar, totals); else host.insertBefore(bar, host.firstChild);
      render(bar);
    });
  }

  var fetching = null;
  function refreshCart() {
    if (fetching) return fetching;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetching = fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart.total = c.total_price || 0; cart.count = c.item_count || 0; })
      .catch(function () {})
      .then(function () { fetching = null; ensureBars(); renderAll(); });
    return fetching;
  }

  var timer = null;
  function onMutations(list) {
    var outside = list.some(function (m) {
      var t = m.target.nodeType === 1 ? m.target : m.target.parentElement;
      return !(t && t.closest && t.closest('.fsb'));
    });
    if (!outside) return;
    clearTimeout(timer);
    timer = setTimeout(function () { ensureBars(); refreshCart(); }, 150);
  }

  function init() {
    var cust = CFG.customer;
    state = saved() || (cust && STATES[cust] ? cust : null);
    ensureBars();
    refreshCart();
    if (!state) detectByIp();
    new MutationObserver(onMutations).observe(document.body, { childList: true, subtree: true });
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { refreshCart(); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
